    import { QueryClient } from '@tanstack/react-query';
    import { persistQueryClient } from '@tanstack/query-persist-client-core';
    import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

    export const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          gcTime: 1000 * 60 * 60 * 24, // 24 hours
        },
      },
    });

    const localStoragePersister = createAsyncStoragePersister({
      storage: window.localStorage,
    });

    persistQueryClient({
      queryClient,
      persister: localStoragePersister,
    });